export type SnListItemDisableExpression = () => boolean;
